import React from 'react';

const LoginWithMotorsportRegButton = (props) => (
  <div className="intro-step-1 text-center">
    <h2>Easy self-service access to request, update and list your credentials</h2>
    <a className="step-1 btn btn-danger btn-msr btn-lg btn-" onClick={() => props.getRequestToken()}>
      <div className="icon-white_m pull-left"></div>
      Login with MotorsportReg
    </a>
    <p>You will be redirected to login with MotorsportReg.com</p>
  </div>
);

export default LoginWithMotorsportRegButton;



// WEBPACK FOOTER //
// ./src/components/LoginForm/LoginWithMotorsportRegButton.js